import { axios } from '../../../services/axios';
import * as CONST from '../../constants';

const onSuccess = (dispatch, data) => {
  dispatch({ type: CONST.MENU_EDIT_SUCCESS, menu: data.menu });
};

const onFailed = (dispatch, error) => {
  dispatch({ type: CONST.MENU_EDIT_ERROR, error });
};

const handleResponse = (dispatch, response) => {
  if (response.status === 200) {
    onSuccess(dispatch, response.data);
  } else {
    onFailed(dispatch, response.data);
  }
};

export const menuEdit = (menuId, data) => {
  return async (dispatch) => {
    dispatch({ type: CONST.MENU_EDIT_REQUEST });

    axios.patch(`/menus/${menuId}`, data).then((response) => {
      handleResponse(dispatch, response);
    });
  };
};
